import { Component } from '@angular/core';
import {animate, style, transition, trigger} from "@angular/animations";
import {NotificationService} from "./notification.service";
import {NgClass, NgForOf} from "@angular/common";

@Component({
  selector: 'notification',
  standalone: true,
  imports: [NgClass],
  template: `
    <div class="toast-container">
      @for (toast of toastService.toasts; track toast.id){
        <div class="toast"
             [ngClass]="toast.type"
             [@toastFade]
        >
          <div class="toast-content">
            @if (toast.type === 'success') {
              <div class="toast-type-image">
                <svg width="24" height="24" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M23.43 1.394L11.7225 15.215L10.6305 15.1655L6 8.573L7.131 7.778L11.247 13.6385L22.3755 0.5L23.43 1.394Z" fill="white"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M10.851 9.161L17.43 1.394L16.3755 0.5L10.0305 7.991L10.851 9.161ZM6.1005 12.6305L6.921 13.8005L5.7225 15.215L4.6305 15.1655L0 8.573L1.131 7.778L5.247 13.6385L6.1005 12.6305Z" fill="white"/>
                </svg>

              </div>
            } @else if (toast.type === 'warning') {
              <div class="toast-type-image">
                <svg width="24" height="24" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.937726 17C0.758174 17 0.59934 16.9586 0.461223 16.8758C0.323106 16.793 0.215682 16.6837 0.138951 16.5479C0.0560806 16.4144 0.0100418 16.27 0.000834038 16.1149C-0.00683912 15.9589 0.0384325 15.8019 0.136649 15.6438L9.19481 0.45208C9.29303 0.293926 9.41119 0.179041 9.54931 0.107425C9.68743 0.035808 9.83782 0 10.0005 0C10.1632 0 10.3132 0.035808 10.4505 0.107425C10.5879 0.179041 10.706 0.293926 10.805 0.45208L19.8643 15.6438C19.9626 15.8019 20.0074 15.9586 19.999 16.1137C19.9913 16.2704 19.9453 16.4151 19.8609 16.5479C19.7842 16.6837 19.6767 16.793 19.5386 16.8758C19.4005 16.9586 19.242 17 19.0633 17H0.937726ZM1.31064 15.881H18.6903L10.0005 1.33386L1.31064 15.881ZM10.0005 14.3323C10.2015 14.3323 10.37 14.2663 10.5058 14.1342C10.6416 14.0022 10.7091 13.8384 10.7083 13.643C10.7076 13.4475 10.6397 13.2841 10.5046 13.1528C10.3696 13.0215 10.2015 12.9552 10.0005 12.9537C9.79946 12.9522 9.63141 13.0182 9.49637 13.1517C9.36132 13.2853 9.29341 13.449 9.29264 13.643C9.29188 13.8369 9.35978 14.0007 9.49637 14.1342C9.63295 14.2677 9.80099 14.3338 10.0005 14.3323ZM10.0005 11.8358C10.1647 11.8358 10.3017 11.7821 10.4114 11.6746C10.5211 11.5672 10.576 11.4344 10.576 11.2763V6.80022C10.576 6.64132 10.5207 6.50816 10.4102 6.40074C10.2997 6.29331 10.1628 6.23997 9.99934 6.24072C9.8359 6.24147 9.69932 6.2948 9.58959 6.40074C9.47987 6.50667 9.425 6.63983 9.425 6.80022V11.2763C9.425 11.4344 9.48025 11.5672 9.59075 11.6746C9.70124 11.7821 9.83821 11.8358 10.0016 11.8358" fill="white"/>
                </svg>

              </div>
            } @else if (toast.type === 'error') {
              <div class="toast-type-image">
                <svg width="24" height="24" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.937726 17C0.758174 17 0.59934 16.9586 0.461223 16.8758C0.323106 16.793 0.215682 16.6837 0.138951 16.5479C0.0560806 16.4144 0.0100418 16.27 0.000834038 16.1149C-0.00683912 15.9589 0.0384325 15.8019 0.136649 15.6438L9.19481 0.45208C9.29303 0.293926 9.41119 0.179041 9.54931 0.107425C9.68743 0.035808 9.83782 0 10.0005 0C10.1632 0 10.3132 0.035808 10.4505 0.107425C10.5879 0.179041 10.706 0.293926 10.805 0.45208L19.8643 15.6438C19.9626 15.8019 20.0074 15.9586 19.999 16.1137C19.9913 16.2704 19.9453 16.4151 19.8609 16.5479C19.7842 16.6837 19.6767 16.793 19.5386 16.8758C19.4005 16.9586 19.242 17 19.0633 17H0.937726ZM1.31064 15.881H18.6903L10.0005 1.33386L1.31064 15.881ZM10.0005 14.3323C10.2015 14.3323 10.37 14.2663 10.5058 14.1342C10.6416 14.0022 10.7091 13.8384 10.7083 13.643C10.7076 13.4475 10.6397 13.2841 10.5046 13.1528C10.3696 13.0215 10.2015 12.9552 10.0005 12.9537C9.79946 12.9522 9.63141 13.0182 9.49637 13.1517C9.36132 13.2853 9.29341 13.449 9.29264 13.643C9.29188 13.8369 9.35978 14.0007 9.49637 14.1342C9.63295 14.2677 9.80099 14.3338 10.0005 14.3323ZM10.0005 11.8358C10.1647 11.8358 10.3017 11.7821 10.4114 11.6746C10.5211 11.5672 10.576 11.4344 10.576 11.2763V6.80022C10.576 6.64132 10.5207 6.50816 10.4102 6.40074C10.2997 6.29331 10.1628 6.23997 9.99934 6.24072C9.8359 6.24147 9.69932 6.2948 9.58959 6.40074C9.47987 6.50667 9.425 6.63983 9.425 6.80022V11.2763C9.425 11.4344 9.48025 11.5672 9.59075 11.6746C9.70124 11.7821 9.83821 11.8358 10.0016 11.8358" fill="white"/>
                </svg>

              </div>
            } @else if (toast.type === 'info') {
              <div class="toast-type-image">
                <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M10 14H10.01V14.01H10V14Z" stroke="white" stroke-width="1.5" stroke-linejoin="round"/>
                  <path d="M10 10V6" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>

              </div>
            }
            <div class="toast-row">
              <div class="toast-header">
                <div class="din-pro-bold toast-title">{{ toast.title }}</div>
                <div class="din-pro-text toast-message">{{ toast.message }}</div>
              </div>
              <svg (click)="closeToast(toast.id)" class="close-btn" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L11 11M1 11L11 1" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
        </div>
      }
    </div>
  `,
  styles: `.toast-container {
  position: fixed;
  top: 30px;
  right: 20px;
  z-index: 9999;
  display: flex;
  flex-direction: column-reverse;
    transition: transform 0.3s ease;
}
  .toast-row{
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    gap: 24px;
  }
.toast {
  padding: 12px 15px 8px 16px;
  border-radius: 12px;
  color: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  min-width: 300px;
  opacity: 1;
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
  position: relative;
}
.toast.success {
  background-color: #43BE00;
}
.toast.error {
  background-color: #E60000;
}
.toast.info {
  background-color: #0D72D0;
}
.toast.warning {
  background-color: #FF8800;
}
.toast-title {
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0;
  vertical-align: middle;
}
.toast-message {
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0;
  vertical-align: middle;
  /*max-width: 250px;*/
}
.toast-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 4px;
  flex-direction: column;
}
.close-btn {

 cursor: pointer;
}

.close-btn:hover {
  color: #ddd;
}
.toast.fade-out {
  opacity: 0;
  transform: translateY(-10px);
}
.toast-type-image {

}
.toast-content {
  display: flex;
  align-items: center;
  gap: 8px;
}
/*.toast-container:hover{*/
/*  transform: scale(1.01);*/
/*}*/
@keyframes toastFadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}
@keyframes toastFadeOut {
  from { opacity: 1; transform: translateY(0); }
  to { opacity: 0; transform: translateY(-10px); }
}
`,
  animations: [
    trigger('toastFade', [
      // Анимация появления
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-10px)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ]),
      // Анимация исчезновения
      transition(':leave', [
        animate('300ms ease-in', style({ opacity: 0, transform: 'translateY(-10px)' }))
      ])
    ])
  ]
})
export class NotificationComponent {

  constructor(public toastService: NotificationService) {}



  closeToast(id: number) {
    this.toastService.remove(id);
  }
}
